<template>
  <div class="section">
    <div class="swiper mySwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="section banner">
            <div class="banner_content">
              <div class="banner_content_title">
                <div style="display: flex;flex-direction: column;" class="title_wrap">
                  <p class="title white">小鳗动态</p>
                  <img src="../../assets/line.png" class="line" style="margin-top: 20px" alt="" />
                  <p class="subtitle white">SMALLEEL NEWS</p>
                </div>
                <div @click="getMore(1)" style="cursor: pointer;">
                  <div class="blue">查看更多 ></div>
                  <img src="../../assets/small_line.png" class="small_line" style="margin-top: 6px" alt="" />
                </div>
              </div>
              <div class="banner_content_news flex'" ref="bannerRef">
                <dl v-for="item in one" :key="item.aid" @click="toDetailone(item)">
                  <dt>
                    <img :src="'https://file.smalleel.com/'+item.coverUrl" class="banner_img" alt="" />
                  </dt>
                  <dd class="mt38" :class="{'animate__animated': true, 'hide': curPage !== 0, 'animate__zoomIn': curPage === 0}">
                    <p class="p1 singe_line">
                      {{ item.title }}
                    </p>
                    <p class="ellipsis3 p2 mt32" v-if="item.firstParagraph" v-html="item.firstParagraph">
                    </p>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="swiper-slide">
          <div class="section news_1">
            <div class="news_content">
              <div class="news_content_title">
                <div style="display: flex;flex-direction: column;" class="title_wrap">
                  <p class="title black">行业资讯</p>
                  <img src="../../assets/line.png" class="line" style="margin-top: 20px" alt="" />
                  <p class="subtitle black">INDUSTRY INFOTMATION</p>
                </div>
                <div style="cursor: pointer;">
                  <div class="blue" @click="getMore(2)">查看更多 ></div>
                  <img src="../../assets/small_line.png" class="small_line" style="margin-top: 6px" alt="" />
                </div>
              </div>
            </div>

            <div class="news_imgContent" v-if="two.length">
              <div class="hotItem news_2__item animate__fadeInUp" @click="toDetailother(two[0].aid,two[0].type)">
                <img :src="'https://file.smalleel.com/'+ two[0].coverUrl" alt="" class="hotItem_img1 shadow" />
                <div class="hotItem_title" :class="{'animate__animated': true, 'hide': curPage !== 1, 'animate__zoomIn': curPage === 1}">
                  <p>{{ two[0].title }}</p>
                  <p v-if="two[0].firstParagraph">
                    <span v-html="two[0].firstParagraph"></span>
                  </p>
                </div>
              </div>
              <div class="news_2__item animate__fadeInUp">
                <div class="hotItem" @click="toDetailother(two[1].aid,two[1].type)">
                  <img :src="'https://file.smalleel.com/'+two[1].coverUrl" alt="" style="display: block;" class="two_samll shadow" />
                  <div class="hotItem_title" :class="{'animate__animated': true, 'hide': curPage !== 1, 'animate__zoomIn': curPage === 1}">
                    <p>
                      {{ two[1].title }}
                    </p>
                    <p v-if="two[1].firstParagraph">
                      <span v-html="two[1].firstParagraph"></span>
                    </p>
                  </div>
                </div>
                <div class="hotItem animate__animated animate__fadeInUp" @click="toDetailother(two[2].aid,two[2].type)">
                  <img :src="'https://file.smalleel.com/'+two[2].coverUrl" alt="" style="display: block;" class="two_samll " />
                  <div class="hotItem_title" :class="{'animate__animated': true, 'hide': curPage !== 1, 'animate__zoomIn': curPage === 1}">
                    <p>
                      {{ two[2].title }}
                    </p>
                    <p v-if="two[1].firstParagraph">
                      <span v-html="two[2].firstParagraph"></span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="section news_3">
            <div class="news_content">
              <div class="news_content_title">
                <div style="display: flex;flex-direction: column;" class="title_wrap">
                  <p class="title white">小鳗课堂</p>
                  <img src="../../assets/line.png" class="line" style="margin-top: 20px" alt="" />
                  <p class="subtitle white">SMALLEEL CLASS</p>
                </div>
                <div style="cursor: pointer;">
                  <div class="blue" @click="getMore(3)">查看更多 ></div>
                  <img src="../../assets/small_line.png" class="small_line" style="margin-top: 6px" alt="" />
                </div>
              </div>
            </div>

            <div class="news_content_title main_content space_between  news_imgContent" style="margin-top: 60px">
              <dl class="animate" v-for="item in three" :key="item.aid" @click="toDetailone(item)" :class="fullpage.current == 3 ? 'animate__animated animate__fadeInUp' : ''">
                <dt>
                  <img :src="'https://file.smalleel.com/'+item.coverUrl" class="news3_img" alt="" />
                </dt>
                <dd :class="{'animate__animated': true, 'hide': curPage !== 2, 'animate__zoomIn': curPage === 2}">
                  <p class="p1 singe_line">
                    {{ item.title }}
                  </p>
                  <p class="ellipsis3 p2" v-if="item.firstParagraph" v-html="item.firstParagraph">
                  </p>
                </dd>
              </dl>
              <!-- <dl>
          <dt>
            <img src="../../assets/news_img5.png" class="news3_img" alt="" />
          </dt>
          <dd>
            <p class="p1 singe_line">商业能源管理系统能为企业带来哪些价值？</p>
            <p class="ellipsis3 p2">
              在“双碳”战略的时代机遇下，储能、风电、光伏、新能源等迎来“黄金增长期”，而能源管理领域也实现弯道超车，成为下一片...蓝海市场。
            </p>
          </dd>
        </dl>
        <dl>
          <dt>
            <img src="../../assets/news_img6.png" class="news3_img" alt="" />
          </dt>
          <dd>
            <p class="p1 singe_line">
              购物中心的低碳之路如何实现？四个阶段入手
            </p>
            <p class="ellipsis3 p2">
              节能减排，设计先行。新建购物中心在设计时就应进行全过程的节能减排考虑，包括主动/被动式节能策略的选择与规划、对场地... 建筑、设备的可持续发展的重视、融入更多绿色元素等等。
            </p>
          </dd>
        </dl> -->
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-scrollbar"></div>

    </div>
  </div>
</template>

<script>
import anime from "animejs";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css"
import Swiper from 'swiper';


export default {
  name: "news",
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      currentScroll: 0,
      work: [],
      screenWidth: document.body.clientWidth,
      fullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0 // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
      },
      swiperOption: {
        observeParents: true,
        slidesPerView: 1, //一行显示3个
        direction: 'vertical',
        mousewheel: true,
        effect: 'fade',
        initialSlide: 1
      },
      startTime: undefined, // 记录触摸开始的时间
      startX: undefined, // 记录触摸开始的X坐标，本次主要实现的是上下滑动，所以当前坐标不做强制要求
      startY: undefined,
      one: [],
      two: [],
      three: [],
      drawer: false,
      direction: 'rtl',
      curPage: 0
    };

  },

  created () {
    this.getNew()
    this.getNew2()
    this.getNew3()
  },
  mounted () {

    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    this.initSwiper()
  },
  methods: {
    initSwiper () {
      let that = this
      var swiper = new Swiper(".mySwiper", {
        direction: "vertical",
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        initialSlide: 0,
        mousewheel: {
          thresholdTime: 2000,
          thresholdDelta: 120
        },
        forceToAxis: true,
        scrollbar: {
          el: '.swiper-scrollbar',
        },
        preventClicks: false,
        preventClicksPropagation: false,
        on: {
          slideChangeTransitionEnd () {
            that.curPage = this.activeIndex

            console.log(that.curPage, 'page')
          }
        }
      });
    },
    toDetailother (id,type) {
      this.$router.push({
        path: '/newDetail/'+ type +'_'+ id + '.html'
      })
    },
    toDetailone(item){
      this.$router.push({
        path: '/newDetail/'+ item.type + '_' + item.aid + '.html'
      })
    },
    getMore (type) {
      this.$router.push({
        name: 'more',
        params: {
          type: type
        }
      })

    },
    async getNew () {
      var params = new URLSearchParams();
      params.append('start', 1);
      params.append('limit', 3);
      params.append('type', 1);
      let res = await this.$axios.post('/api/websiteNews/websiteList', params)
      let list = JSON.parse(JSON.stringify(res.data.data.records))
      this.one = list

    },
    async getNew2 () {
      var params = new URLSearchParams();
      params.append('start', 1);
      params.append('limit', 3);
      params.append('type', 2);
      let res = await this.$axios.post('/api/websiteNews/websiteList', params)
      let list = JSON.parse(JSON.stringify(res.data.data.records))
      this.two = list

    },
    async getNew3 () {
      var params = new URLSearchParams();
      params.append('start', 1);
      params.append('limit', 3);
      params.append('type', 3);
      let res = await this.$axios.post('/api/websiteNews/websiteList', params)
      let list = JSON.parse(JSON.stringify(res.data.data.records))
      this.three = list
    },
    handleScroll () {
      this.currentScroll = window.pageYOffset;

      if (this.currentScroll >= this.$refs.bannerRef.offsetTop - 20) {
        this.runAnime();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/style/news.scss';
.banner {
  width: 100%;
  background: url('https://file.smalleel.com/2023/08/28/1693187233Y8AhY.png') no-repeat;
  background-position: center;
  background-size: cover;
  .banner_content {
    width: 1200px;
    margin: auto;
    text-align: left;
    padding-top: 100px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .banner_content_title {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }
    .banner_content_news {
      display: flex;
      justify-content: space-between;
      margin-top: 60px;
      cursor: pointer;
    }
  }

  p {
    width: 360px;
  }
}

.news_1 {
  width: 100%;
  background: url('../../assets/home_content_bg.png') no-repeat;
  background-position: center;
  background-size: cover;
  /* display: flex;
  flex-direction: column; */
  .hotItem {
    position: relative;
  }

  .hotItem_img1 {
    width: 662px;
    height: 500px;
    cursor: pointer;
    object-fit: cover;
    flex: 1;
  }
  .hotItem_title {
    box-sizing: border-box;
    width: 100%;
    position: absolute;
    bottom: 0;
    padding: 0 24px;
    background: linear-gradient(rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0.6)) 90%;
    p {
      font-family: 'Medium';
      font-weight: 500;
      color: #ffffff;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: break-word;
      word-break: break-all;
      width: 500px;
      margin: 0;
      padding: 0;
      margin-bottom: 15px;
    }

    span {
      font-size: 14px;
      font-family: 'Light';
      font-weight: 300;
      color: #ffffff;
      line-height: 20px;
      opacity: 0.8;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}

.news_3 {
  width: 100%;
  background: url('../../assets/news_bg.png') no-repeat;
  background-position: center;
  background-size: cover;
  .news3_img {
    width: 360px;
    height: 500px;
    cursor: pointer;
    object-fit: cover;
    flex: 1;
  }
  dl {
    position: relative;
  }

  dd {
    position: absolute;
    /* bottom: 20px; */
    bottom: 0;

    p {
      padding: 0 20px;
    }
  }

  .p1 {
    width: 360px;
  }
}

.news_imgContent {
  width: 1200px;
  margin-left: 24px;
  margin-right: 24px;
  display: flex;
  justify-content: space-between;
  margin: auto;
  margin-top: 70px;
  dd {
    background: linear-gradient(rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0.6)) 90%;
  }
}
.news_content {
  width: 1200px;
  margin: auto;
  text-align: left;
  padding-top: 100px;

  .news_content_title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .news_content_news {
    display: flex;
    justify-content: space-between;
    margin-top: 60px;
  }
}

.p1 {
  font-size: 18px;
  font-family: 'Medium';
  font-weight: 500;
  color: #ffffff;
  line-height: 30px;
}
.p2 {
  font-size: 14px;
  font-family: 'Light';
  font-weight: 300;
  color: #ffffff;
  opacity: 0.8;
  line-height: 30px !important;
}

.title {
  font-size: 48px;
  font-family: 'PangMenZhengDao';
  font-weight: 400;
  letter-spacing: 6px;
}

.subtitle {
  font-size: 24px;
  font-family: 'PangMenZhengDao';
  font-weight: 400;
  margin-top: 20px;
}

.banner_img {
  width: 360px;
  height: 240px;
  object-fit: cover;
  flex: 1;
}

/* .banner_img:hover {
  transform: scale(1.1);
} */

.two_samll {
  width: 540px;
  height: 250px;
  cursor: pointer;
  object-fit: cover;
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/news.vue